import * as React from 'react';
import Popup from "reactjs-popup";
import * as Sentry from "@sentry/browser";

interface ModalProps {
    children: React.ReactElement
    trigger: React.ReactElement
    isLoaded: boolean
}

export const Modal: React.FC<ModalProps> = ({ children, trigger, isLoaded }) => {
    const [opened, setOpened] = React.useState(true)

    const close = () => setOpened(false)
    const open = () => {
        setOpened(true)
        Sentry.addBreadcrumb({
            category: 'ui',
            message: `Opened "new flow" modal`,
            level: Sentry.Severity.Info,
            type: 'user',
        });
    }

    const contentStyle = isLoaded ? {
        position: 'fixed' as const,
        top: '20px',
        left: '100px',
        width: 'calc(100vw - 200px)',
        height: 'calc(100vh - 40px)',
        margin: '0',
        padding: '60px 40px 40px 40px',
        overflow: 'hidden',
        borderRadius: '40px',
        border: '2px solid var(--foreground)',
        backgroundColor: 'var(--background)',
        pointerEvents: 'auto' as const,
    } : {};

    console.log('MODAL COMPONENT: isLoaded=', isLoaded, 'contentStyle=', contentStyle);

    return <Popup
        trigger={trigger}
        onOpen={open}
        open={opened}
        closeOnDocumentClick={false}
        modal
        className={`new_screen_modal${isLoaded ? "-loaded" : ""}`}
        contentStyle={contentStyle}
    >
        {children}
    </Popup>
}

export default Modal;